/**
 * Block Link Group.
 */
import { breakpoints } from './variables';

const linkGroups = document.querySelectorAll('.em-link-groups');
const setLinkGroupHeights = () => {
	linkGroups.forEach((group) => {
		const children = Object.entries(group.children);
		let baseHeight = 0;

		if (breakpoints.sm.aboveMin()) {
			children.forEach((groupItem) => {
				const item = groupItem[1];
				const height = item.offsetHeight;
				if (height > baseHeight) {
					baseHeight = height;
				}
			});
			children.forEach((groupItem) => {
				const item = groupItem[1];
				item.setAttribute('style', `height:${baseHeight}px`);
				item.style.height = baseHeight;
			});
		}
	});
};

document.addEventListener('DOMContentLoaded', setLinkGroupHeights);
